import { apiSlice } from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => ({
        url: "/tasks",
        method: "GET",
      }),
    }),
    getTask: builder.query({
      query: (taskId) => ({
        url: `/tasks/${taskId}`,
        method: "GET",
      }),
    }),
    addTask: builder.mutation({
      query: (task) => ({
        url: "/tasks",
        method: "POST",
        body: task,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;

          if (result?.data) {
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                draft.push(result.data);
              })
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    editTask: builder.mutation({
      query: (data) => ({
        url: `/tasks/${data.id}`,
        method: "PUT",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // pessimistically update the task in the store
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const task = draft.find((task) => task.id == arg.id);
              task.taskName = data.taskName;
              task.teamMember = data.teamMember;
              task.project = data.project;
              task.deadline = data.deadline;
              task.status = data.status;
            })
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deleteTask: builder.mutation({
      query: (taskId) => ({
        url: `/tasks/${taskId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // optimistically remove the task from the store
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const taskIndex = draft.findIndex((task) => task.id == arg.taskId);
            draft.splice(taskIndex, 1);
          })
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useAddTaskMutation,
  useEditTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
